import React from 'react';

import { useStoreContext } from 'features/store';
import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

import { FriesSvg as UnauthenticatedEmptyStateImage } from '../../../../../components/svgs/fries';

import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const NoRecentOrdersEmptyState = () => {
  const { formatMessage } = useIntl();
  const { isStoreOpenAndAvailable } = useStoreContext();

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <UnauthenticatedEmptyStateImage />
      </ImageWrapper>
      <HeaderText testID="text-no-recent-items">
        {formatMessage({ id: 'noRecentItemsHeader' })}
      </HeaderText>
      <SubText>{formatMessage({ id: 'noRecentItemsSubheader' })}</SubText>
      <StyledActionButtonLink
        to={isStoreOpenAndAvailable ? `${routes.menu}` : `${routes.storeLocator}`}
        style={{ marginTop: '10%' }}
      >
        {formatMessage({ id: 'orderNow' })}
      </StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default NoRecentOrdersEmptyState;
